/**
 * @generated SignedSource<<dec06747a97c05bd2ad3b6d06ab22cd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orderId",
        "variableName": "orderId"
      }
    ],
    "concreteType": "Order",
    "kind": "LinkedField",
    "name": "CancelOrderCollect",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primeCustomerAction",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CancelCollectModalMutation",
    "selections": (v1/*: any*/),
    "type": "ClientAppMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CancelCollectModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "37dd32bb96b9e902104e083a6c9e48ef",
    "id": null,
    "metadata": {},
    "name": "CancelCollectModalMutation",
    "operationKind": "mutation",
    "text": "mutation CancelCollectModalMutation(\n  $orderId: Int!\n) {\n  CancelOrderCollect(orderId: $orderId) {\n    id\n    status\n    primeCustomerAction\n  }\n}\n"
  }
};
})();

node.hash = "697c6b6a06f2b6b61ab172953a766649";

module.exports = node;
